// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Panel content primitives ─────────────────────────────────────────
   Display atoms for an entity's detail surface. Shared by the drawer
   (RightSidebar) and any inline-panel / full-page layout that composes the
   same detail content. Class prefix \`rsb-\` retained for backward compatibility
   with existing consumer markup. */

/* ── Field rows ───────────────────────────────────────────────────
   Matches the app's InputRow: a mono uppercase label column + value on a
   fixed grid, baseline-aligned — the same read-only row used in the org
   member modal. */
.rsb-field {
  display: grid;
  grid-template-columns: 116px 1fr;
  gap: 14px;
  padding: 8px 0;
  align-items: baseline;
}

.rsb-field__label {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  line-height: 1.4;
  color: var(--text-muted, #6b7287);
}

.rsb-field__value {
  font-size: var(--fs-2xs);
  line-height: 1.5;
  color: var(--text, #0e1428);
}

/* Codes and figures align on tabular numerals. */
.rsb-field__value--mono {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-variant-numeric: tabular-nums;
}

/* Missing data reads as a quiet placeholder, not primary content. */
.rsb-field__value--empty {
  color: var(--text-muted, #6b7287);
}

/* A parenthetical delta after a value (e.g. days-to-deadline "(13 d)"): the
   relative figure rides quietly behind the absolute date. */
.rsb-field__delta {
  color: var(--text-muted, #6b7287);
}

/* ── Entity list ──────────────────────────────────────────────────
   A list of records inside a panel (e.g. the receptores serving a
   tribunal): name over a quiet meta line, rows split by hairlines. */
.rsb-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.rsb-list__item {
  padding: 10px 0;
  border-bottom: 1px solid var(--border-soft, #e8e2ce);
}

.rsb-list__item:last-child {
  border-bottom: none;
}

.rsb-list__name {
  font-size: var(--fs-ui);
  line-height: 1.35;
  color: var(--text, #0e1428);
}

.rsb-list__meta {
  margin-top: 2px;
  font-size: var(--fs-meta);
  line-height: 1.4;
  color: var(--text-muted, #6b7287);
}

.rsb-empty {
  padding: 8px 0;
  font-size: var(--fs-ui);
  color: var(--text-muted, #6b7287);
}

/* ── Field groups ─────────────────────────────────────────────────
   A titled cluster of fields; groups after the first are divided by a
   hairline, echoing the ledger rules. */
.rsb-section + .rsb-section {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid var(--border, #d9d2bd);
}

.rsb-section__label {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-micro);
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted, #6b7287);
  margin-bottom: 12px;
}

/* Section header row — label on the left, an optional contextual action
   (icon CTA) on the right. The label drops its standalone bottom margin here. */
.rsb-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.rsb-section__head .rsb-section__label {
  margin-bottom: 0;
}

/* Right-side cluster in a section head — e.g. a status Badge + an icon CTA. */
.rsb-section__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Contextual CTA: an icon button in the navy accent (the system's interactive
   color). A soft paper disc + a deeper navy appear on hover. Tooltip via title. */
.rsb-iconbtn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--signal, #0c6bf0);
  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.rsb-iconbtn:hover {
  background: var(--bg, #f8f6ee);
  color: var(--signal-deep, #0957c8);
}

.rsb-iconbtn:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}

.rsb-iconbtn svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  stroke-width: 1.5;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* Collapsible section — the head toggles; a one-line summary shows when closed
   (progressive disclosure for optional / high-volume detail like PJUD status). */
.rsb-section__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.rsb-section__toggle .rsb-section__label {
  margin-bottom: 0;
}

/* Only when open does the toggle need the 12px gap before its content —
   collapsed it's header-only, so no trailing gap (avoids the jump). */
.rsb-section__toggle--open {
  margin-bottom: 12px;
}

.rsb-section__chevron {
  flex-shrink: 0;
  display: inline-flex;
  color: var(--text-muted, #6b7287);
  transition: transform 150ms ease;
}

.rsb-section__chevron svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  stroke-width: 1.5;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.rsb-section__chevron--open {
  transform: rotate(90deg);
}

.rsb-section__summary {
  margin-top: 8px;
  font-size: var(--fs-meta);
  line-height: 1.5;
  color: var(--text-secondary, #38415a);
}

/* Item count in a collapsible section head (e.g. nº de actuaciones), sitting
   just before the chevron. \`margin-left: auto\` keeps the label on the left and
   clusters the count + chevron on the right. Quiet mono numeral; tabular so the
   digits don't jitter as the value updates. */
.rsb-section__count {
  flex-shrink: 0;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-sm);
  font-variant-numeric: tabular-nums;
  color: var(--text-muted, #6b7287);
}

/* Disabled collapsible (a section with zero items): non-interactive and visibly
   muted, but it still shows its label + count so the empty state reads. */
.rsb-section__toggle:disabled {
  cursor: default;
}

.rsb-section__toggle:disabled .rsb-section__label,
.rsb-section__toggle:disabled .rsb-section__count,
.rsb-section__toggle:disabled .rsb-section__chevron {
  opacity: 0.5;
}

/* Status badge — a semantic dot + mono caps label. The dot carries the meaning
   (color communicates status); the label stays quiet ink. */
.rsb-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-micro);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary, #38415a);
  white-space: nowrap;
}

.rsb-badge__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  flex-shrink: 0;
}

.rsb-badge--ok .rsb-badge__dot {
  background: var(--ok, #117a39);
}
.rsb-badge--warn .rsb-badge__dot {
  background: var(--warn, #b45309);
}
.rsb-badge--info .rsb-badge__dot {
  background: var(--signal, #0c6bf0);
}
.rsb-badge--danger .rsb-badge__dot {
  background: var(--danger, #b42318);
}
.rsb-badge--muted {
  color: var(--text-muted, #6b7287);
}
.rsb-badge--muted .rsb-badge__dot {
  background: transparent;
  border: 1.5px solid var(--text-muted, #6b7287);
}

/* Metadata footer line (e.g. "Última actualización · hace X") — quiet, fills
   the footer; replaces the action buttons when the panel has no primary CTA. */
.rsb-foot-meta {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.rsb-foot-meta__l {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted, #6b7287);
}

/* The relative-time value ("hace 6 h") shares the metadata's mono treatment so
   it reads as one unit with the uppercase mono label, not the body sans. */
.rsb-foot-meta__v {
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-sm);
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary, #38415a);
}

.rsb-foot-meta__v--flag {
  color: var(--warn, #b45309);
  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);
  font-size: var(--fs-sm);
}
`, "",{"version":3,"sources":["webpack://./src/shared/PanelPrimitives/PanelPrimitives.css"],"names":[],"mappings":"AAAA;;;;mCAImC;;AAEnC;;;kBAGkB;AAClB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,mEAAmE;EACnE,kCAAkC;AACpC;;AAEA,oEAAoE;AACpE;EACE,iCAAiC;AACnC;;AAEA;4DAC4D;AAC5D;EACE,iCAAiC;AACnC;;AAEA;;qEAEqE;AACrE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;wCAEwC;AACxC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;gFACgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;kFACkF;AAClF;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;iFACiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;sEACsE;AACtE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;;8CAG8C;AAC9C;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mEAAmE;EACnE,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;0EAC0E;AAC1E;EACE,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;4DAC4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mEAAmE;EACnE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;+EAC+E;AAC/E;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;2EAC2E;AAC3E;EACE,mEAAmE;EACnE,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,mEAAmE;EACnE,uBAAuB;AACzB","sourcesContent":["/* ── Panel content primitives ─────────────────────────────────────────\n   Display atoms for an entity's detail surface. Shared by the drawer\n   (RightSidebar) and any inline-panel / full-page layout that composes the\n   same detail content. Class prefix `rsb-` retained for backward compatibility\n   with existing consumer markup. */\n\n/* ── Field rows ───────────────────────────────────────────────────\n   Matches the app's InputRow: a mono uppercase label column + value on a\n   fixed grid, baseline-aligned — the same read-only row used in the org\n   member modal. */\n.rsb-field {\n  display: grid;\n  grid-template-columns: 116px 1fr;\n  gap: 14px;\n  padding: 8px 0;\n  align-items: baseline;\n}\n\n.rsb-field__label {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  line-height: 1.4;\n  color: var(--text-muted, #6b7287);\n}\n\n.rsb-field__value {\n  font-size: var(--fs-2xs);\n  line-height: 1.5;\n  color: var(--text, #0e1428);\n}\n\n/* Codes and figures align on tabular numerals. */\n.rsb-field__value--mono {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Missing data reads as a quiet placeholder, not primary content. */\n.rsb-field__value--empty {\n  color: var(--text-muted, #6b7287);\n}\n\n/* A parenthetical delta after a value (e.g. days-to-deadline \"(13 d)\"): the\n   relative figure rides quietly behind the absolute date. */\n.rsb-field__delta {\n  color: var(--text-muted, #6b7287);\n}\n\n/* ── Entity list ──────────────────────────────────────────────────\n   A list of records inside a panel (e.g. the receptores serving a\n   tribunal): name over a quiet meta line, rows split by hairlines. */\n.rsb-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.rsb-list__item {\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-soft, #e8e2ce);\n}\n\n.rsb-list__item:last-child {\n  border-bottom: none;\n}\n\n.rsb-list__name {\n  font-size: var(--fs-ui);\n  line-height: 1.35;\n  color: var(--text, #0e1428);\n}\n\n.rsb-list__meta {\n  margin-top: 2px;\n  font-size: var(--fs-meta);\n  line-height: 1.4;\n  color: var(--text-muted, #6b7287);\n}\n\n.rsb-empty {\n  padding: 8px 0;\n  font-size: var(--fs-ui);\n  color: var(--text-muted, #6b7287);\n}\n\n/* ── Field groups ─────────────────────────────────────────────────\n   A titled cluster of fields; groups after the first are divided by a\n   hairline, echoing the ledger rules. */\n.rsb-section + .rsb-section {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid var(--border, #d9d2bd);\n}\n\n.rsb-section__label {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-micro);\n  font-weight: 500;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted, #6b7287);\n  margin-bottom: 12px;\n}\n\n/* Section header row — label on the left, an optional contextual action\n   (icon CTA) on the right. The label drops its standalone bottom margin here. */\n.rsb-section__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.rsb-section__head .rsb-section__label {\n  margin-bottom: 0;\n}\n\n/* Right-side cluster in a section head — e.g. a status Badge + an icon CTA. */\n.rsb-section__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n/* Contextual CTA: an icon button in the navy accent (the system's interactive\n   color). A soft paper disc + a deeper navy appear on hover. Tooltip via title. */\n.rsb-iconbtn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--signal, #0c6bf0);\n  cursor: pointer;\n  transition:\n    background 120ms ease,\n    color 120ms ease;\n}\n\n.rsb-iconbtn:hover {\n  background: var(--bg, #f8f6ee);\n  color: var(--signal-deep, #0957c8);\n}\n\n.rsb-iconbtn:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring);\n}\n\n.rsb-iconbtn svg {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  stroke-width: 1.5;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* Collapsible section — the head toggles; a one-line summary shows when closed\n   (progressive disclosure for optional / high-volume detail like PJUD status). */\n.rsb-section__toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n}\n\n.rsb-section__toggle .rsb-section__label {\n  margin-bottom: 0;\n}\n\n/* Only when open does the toggle need the 12px gap before its content —\n   collapsed it's header-only, so no trailing gap (avoids the jump). */\n.rsb-section__toggle--open {\n  margin-bottom: 12px;\n}\n\n.rsb-section__chevron {\n  flex-shrink: 0;\n  display: inline-flex;\n  color: var(--text-muted, #6b7287);\n  transition: transform 150ms ease;\n}\n\n.rsb-section__chevron svg {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  stroke-width: 1.5;\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.rsb-section__chevron--open {\n  transform: rotate(90deg);\n}\n\n.rsb-section__summary {\n  margin-top: 8px;\n  font-size: var(--fs-meta);\n  line-height: 1.5;\n  color: var(--text-secondary, #38415a);\n}\n\n/* Item count in a collapsible section head (e.g. nº de actuaciones), sitting\n   just before the chevron. `margin-left: auto` keeps the label on the left and\n   clusters the count + chevron on the right. Quiet mono numeral; tabular so the\n   digits don't jitter as the value updates. */\n.rsb-section__count {\n  flex-shrink: 0;\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-sm);\n  font-variant-numeric: tabular-nums;\n  color: var(--text-muted, #6b7287);\n}\n\n/* Disabled collapsible (a section with zero items): non-interactive and visibly\n   muted, but it still shows its label + count so the empty state reads. */\n.rsb-section__toggle:disabled {\n  cursor: default;\n}\n\n.rsb-section__toggle:disabled .rsb-section__label,\n.rsb-section__toggle:disabled .rsb-section__count,\n.rsb-section__toggle:disabled .rsb-section__chevron {\n  opacity: 0.5;\n}\n\n/* Status badge — a semantic dot + mono caps label. The dot carries the meaning\n   (color communicates status); the label stays quiet ink. */\n.rsb-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #38415a);\n  white-space: nowrap;\n}\n\n.rsb-badge__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.rsb-badge--ok .rsb-badge__dot {\n  background: var(--ok, #117a39);\n}\n.rsb-badge--warn .rsb-badge__dot {\n  background: var(--warn, #b45309);\n}\n.rsb-badge--info .rsb-badge__dot {\n  background: var(--signal, #0c6bf0);\n}\n.rsb-badge--danger .rsb-badge__dot {\n  background: var(--danger, #b42318);\n}\n.rsb-badge--muted {\n  color: var(--text-muted, #6b7287);\n}\n.rsb-badge--muted .rsb-badge__dot {\n  background: transparent;\n  border: 1.5px solid var(--text-muted, #6b7287);\n}\n\n/* Metadata footer line (e.g. \"Última actualización · hace X\") — quiet, fills\n   the footer; replaces the action buttons when the panel has no primary CTA. */\n.rsb-foot-meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 100%;\n}\n\n.rsb-foot-meta__l {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted, #6b7287);\n}\n\n/* The relative-time value (\"hace 6 h\") shares the metadata's mono treatment so\n   it reads as one unit with the uppercase mono label, not the body sans. */\n.rsb-foot-meta__v {\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-sm);\n  font-variant-numeric: tabular-nums;\n  color: var(--text-secondary, #38415a);\n}\n\n.rsb-foot-meta__v--flag {\n  color: var(--warn, #b45309);\n  font-family: var(--mono, 'JetBrains Mono', ui-monospace, monospace);\n  font-size: var(--fs-sm);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
